import "bootstrap-icons/font/bootstrap-icons.css";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { FiArrowLeft } from "react-icons/fi";
import { useIntl } from "react-intl";
import Skeleton from "react-loading-skeleton";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import SweetAlert2 from "react-sweetalert2";
import { useAuth } from "../../../auth/components/AuthInit";
import { Overlay } from "../../../common/components/Overlay";
import * as actions from "../../redux/SettingAction";

export const Group = () => {
  const [swalProps, setSwalProps] = useState({});
  const intl = useIntl();
  const dispatch = useDispatch();
  const settingState = useSelector(({ setting }) => setting, shallowEqual);
  const { auth } = useAuth();
  const [targetmemberid, settargetmemberid] = useState();

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const options = {
    responsive: true,
    plugins: {
      legend: {
        labels: {
          color: "#ffffff", // white font for legend
        },
      },
      title: {
        display: true,
        text: intl.formatMessage({ id: "commission" }),
        color: "#ffffff", // white title
      },
      tooltip: {
        backgroundColor: "#333",
        titleColor: "#fff",
        bodyColor: "#fff",
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#ffffff", // white font for x-axis labels
        },
        grid: {
          color: "rgba(255, 255, 255, 0.1)", // light grid lines
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          color: "#ffffff", // white font for y-axis labels
        },
        grid: {
          color: "rgba(255, 255, 255, 0.1)",
        },
      },
    },
  };

  useEffect(() => {
    dispatch(actions.getGroupList({ targetmemberid: auth.memberid }));
  }, []);

  return (
    <div>
      <div style={styles.navBar} className="position-relative">
        <div style={styles.backButton}>
          <Link to="/setting/profile">
            <FiArrowLeft style={{ color: "white" }} />
          </Link>
        </div>
        <div style={styles.title} className="text-font4">
          {intl.formatMessage({ id: "group" })}
        </div>
      </div>
      {settingState.actionsLoading && <Overlay />}
      <SweetAlert2
        heightAuto={false}
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
      />
      <div
        style={{
          width: "95%",
          margin: "10px auto",
          padding: "5px",
          color: "white",
          fontSize: "12px",
          borderRadius: "5px",
        }}
      >
        {settingState.groupList ? (
          <div>
            <div className="d-flex align-items-center justify-content-between  mb-2">
              <div
                className="p-1 rounded col-4"
                style={{ backgroundColor: "#1c1e23" }}
              >
                <div className="text-center">
                  {intl.formatMessage({ id: "downline" })}
                </div>
                <div className="text-center">
                  {settingState.groupList.downlinecount}
                </div>
              </div>
              <div
                className="p-1 rounded col-4"
                style={{ backgroundColor: "#1c1e23" }}
              >
                <div className="text-center">
                  {intl.formatMessage({ id: "commission" })}
                </div>
                <div className="text-center">
                  {settingState.groupList.totalcomm}
                </div>
              </div>
            </div>
            <div
              className="rounded p-2 mb-2"
              style={{
                backgroundColor: "#1c1e23",
              }}
            >
              <Bar
                data={{
                  labels: settingState.groupList.memberCommissions.map(
                    (item) => item.transdate
                  ),
                  datasets: [
                    {
                      label: intl.formatMessage({ id: "commission" }),
                      data: settingState.groupList.memberCommissions.map(
                        (item) => parseFloat(item.commission)
                      ),
                      backgroundColor: "rgba(75, 192, 192, 0.6)",
                      borderRadius: 5,
                    },
                  ],
                }}
                options={options}
              />
            </div>
            <div
              className="rounded p-2"
              style={{
                backgroundColor: "#1c1e23",
              }}
            >
              <div className="text-center fw-semibold mb-2">
                {intl.formatMessage({ id: "memberGroup" })}
              </div>
              {settingState.groupList.memberGroups.length > 0 ? (
                <div className="d-flex flex-column gap-2">
                  {settingState.groupList.memberGroups.map((member) => (
                    <DownlineDetail member={member} key={member.memberid} />
                  ))}
                </div>
              ) : (
                <div
                  className="text-font3"
                  style={{
                    color: "white",
                    textAlign: "center",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                  }}
                >
                  {intl.formatMessage({ id: "noRecordFound" })}
                </div>
              )}
            </div>
          </div>
        ) : (
          <Skeleton className="w-100" height="600px" />
        )}
      </div>
    </div>
  );
};
const DownlineDetail = ({ member }) => {
  const intl = useIntl();

  const [isShow, setIsShow] = useState(false);

  return (
    <div>
      <div className="d-flex align-items-center gap-2">
        <div>
          {" - "}
          {member.username}
        </div>
        <div
          className="border rounded px-1"
          style={{ fontSize: "11px" }}
          onClick={() => setIsShow((prev) => !prev)}
        >
          {" "}
          {intl.formatMessage({ id: "downline" })}
          {" : "}
          {member.membercount}
        </div>
      </div>
      {isShow && member.membercount !== "0" && (
        <Downline targetmemberid={member.memberid} />
      )}
    </div>
  );
};
const Downline = ({ targetmemberid }) => {
  const dispatch = useDispatch();
  const [memberGroups, setMemberGroups] = useState();

  useEffect(() => {
    dispatch(actions.getGroupList({ targetmemberid, dontSave: true })).then(
      (resp) => {
        resp = resp.data;

        setMemberGroups(resp.memberGroups);
      }
    );
  }, []);

  return (
    <div className="ps-2 pt-2">
      <div className="d-flex flex-column gap-2">
        {memberGroups?.map((member) => (
          <DownlineDetail member={member} key={member.memberid} />
        ))}
      </div>
    </div>
  );
};

const styles = {
  navBar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "60px",
    backgroundColor: "black",
  },
  backButton: {
    position: "absolute",
    left: "10px",
    fontSize: "20px",
  },
  title: {
    fontWeight: "bold",
    color: "white",
  },
};
